import { render, staticRenderFns } from "./DirectSchoolPhotos.vue?vue&type=template&id=6403a158&scoped=true&"
import script from "./DirectSchoolPhotos.vue?vue&type=script&lang=js&"
export * from "./DirectSchoolPhotos.vue?vue&type=script&lang=js&"
import style0 from "./DirectSchoolPhotos.vue?vue&type=style&index=0&id=6403a158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6403a158",
  null
  
)

export default component.exports